import './commonAssets';

import '../audioblocks/stylesheets/audioblocks-style-custom.less';
import '../audioblocks/stylesheets/modules/details-uff.less';
import '../common/stylesheets/modules/details-uff.less';
import '../common/stylesheets/modules/notfound/not-found.less';
import '../common/stylesheets/modules/popups/paymentMethodInfo.less';
import '../common/stylesheets/modules/survey/survey.less';
import '../common/stylesheets/modules/widgets/full-width-background-widget.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget-card-design.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget.less';
import '../../assets/common/stylesheets/modules/signup/user-lead-form-innards.less';


import AppLoader from '../react/AppLoader/AppLoader';
import AudioDetailsContainer from '../react/Details/containers/AudioDetailsContainer';
import ReactToastifyContainer from '../react/ReactToastify/containers/ReactToastifyContainer';
import NPSModalLoaderContainer from '../react/NPSModalLoader/NPSModalLoaderContainer';
import PopUpsContainer from '../react/PopUps/PopUpsContainer';
import AudioContainer from '../react/Audio/containers/AudioContainer';
import AudioSiteConstants from '../react/common/SiteConstants/AudioSiteConstants';
import EntTrialBanner from "../react/Trials/EntTrialBanner";
import NavApps from "../react/app/NavApps";

AppLoader.load({
  routes: [
    {
      name: 'Details',
      path: new AudioSiteConstants().getDetailsRoute(),
      component: AudioDetailsContainer,
    },
  ],
  auxApps: {
    ...NavApps,
    'audio-app': AudioContainer,
    'pop-up-container': PopUpsContainer, // FIXME: causes missing matching <div> in <section>
    'nps-modal': NPSModalLoaderContainer,
    'react-toastify-container': ReactToastifyContainer, // FIXME: causes missing matching <div> in <section>
  },
  propBasedApps: {
    'entTrialBanner': EntTrialBanner
  },
});
